import { getCrmCreationSourceDisplayName } from "@rebuild/shared";
import type { Estimation } from "@/interfaces/estimation.interface";
import { PersonBadge } from "./PersonBadge";

type CreatedByBadgeProps = {
  estimation: Pick<Estimation, "createdByUserId" | "creationSource"> | undefined;
};

export const CreatedByBadge = ({ estimation }: CreatedByBadgeProps) => {
  const crmSourceDisplayName = getCrmCreationSourceDisplayName(estimation?.creationSource);
  if (!estimation?.createdByUserId && crmSourceDisplayName) {
    return <span>{crmSourceDisplayName}</span>;
  }

  return <PersonBadge id={estimation?.createdByUserId} emptyLabel="—" unresolvedLabel="Unknown" />;
};
